import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  zCompanyPeopleSortColumn,
  zSortDirection,
  zTeamConnectionStatus,
} from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

export const zCompanyPeopleTableSortColumn = zCompanyPeopleSortColumn.extract([
  'name',
  'company_team_status',
  'recommendations_count',
]);

export type CompanyPeopleTableSortColumn = z.infer<
  typeof zCompanyPeopleTableSortColumn
>;

const schema = z.object({
  company_team_status: zFiltersArray(zTeamConnectionStatus),
  has_metadata: z.enum(['yes', 'no']).optional().catch(undefined),
  order: zSortDirection.optional().catch('asc'),
  sort: zCompanyPeopleTableSortColumn.optional().catch('name'),
});

export type CompanyPeopleSearchSchema = z.infer<typeof schema>;

export const Route = createFileRoute(
  '/_private/_route/_internal/companies/$companyId/people/',
)({
  validateSearch: schema,
});
